import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import { N8nCredentials } from '../../api/n8n';

const state = {
  records: [],
  credentialTypes: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isFetchingTypes: false,
    isTesting: false,
  },
};

export const getters = {
  getCredentials(_state) {
    return _state.records.sort((a, b) => a.name.localeCompare(b.name));
  },
  getCredentialById: _state => id => {
    return _state.records.find(credential => credential.id === id);
  },
  getCredentialsByType: _state => type => {
    return _state.records.filter(
      credential => credential.credential_type === type
    );
  },
  getCredentialTypes(_state) {
    return _state.credentialTypes;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async fetch({ commit }) {
    commit(types.default.SET_N8N_CREDENTIALS_UI_FLAG, { isFetching: true });
    try {
      const response = await N8nCredentials.get();
      commit(types.default.SET_N8N_CREDENTIALS, response.data);
    } catch (error) {
      throw error;
    } finally {
      commit(types.default.SET_N8N_CREDENTIALS_UI_FLAG, { isFetching: false });
    }
  },

  async fetchTypes({ commit }) {
    commit(types.default.SET_N8N_CREDENTIALS_UI_FLAG, {
      isFetchingTypes: true,
    });
    try {
      const response = await N8nCredentials.getTypes();
      commit(types.default.SET_N8N_CREDENTIAL_TYPES, response.data);
    } catch (error) {
      throw error;
    } finally {
      commit(types.default.SET_N8N_CREDENTIALS_UI_FLAG, {
        isFetchingTypes: false,
      });
    }
  },

  async create({ commit }, payload) {
    commit(types.default.SET_N8N_CREDENTIALS_UI_FLAG, { isCreating: true });
    try {
      const response = await N8nCredentials.create(payload);
      commit(types.default.ADD_N8N_CREDENTIAL, response.data);
      return response.data;
    } catch (error) {
      throw error;
    } finally {
      commit(types.default.SET_N8N_CREDENTIALS_UI_FLAG, { isCreating: false });
    }
  },

  async update({ commit }, { id, ...updateObj }) {
    commit(types.default.SET_N8N_CREDENTIALS_UI_FLAG, { isUpdating: true });
    try {
      const response = await N8nCredentials.update(id, updateObj);
      commit(types.default.UPDATE_N8N_CREDENTIAL, response.data);
      return response.data;
    } catch (error) {
      throw error;
    } finally {
      commit(types.default.SET_N8N_CREDENTIALS_UI_FLAG, { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit(types.default.SET_N8N_CREDENTIALS_UI_FLAG, { isDeleting: true });
    try {
      await N8nCredentials.delete(id);
      commit(types.default.DELETE_N8N_CREDENTIAL, id);
    } catch (error) {
      throw error;
    } finally {
      commit(types.default.SET_N8N_CREDENTIALS_UI_FLAG, { isDeleting: false });
    }
  },

  async test({ commit }, id) {
    commit(types.default.SET_N8N_CREDENTIALS_UI_FLAG, { isTesting: true });
    try {
      const response = await N8nCredentials.test(id);
      return response.data;
    } catch (error) {
      throw error;
    } finally {
      commit(types.default.SET_N8N_CREDENTIALS_UI_FLAG, { isTesting: false });
    }
  },
};

export const mutations = {
  [types.default.SET_N8N_CREDENTIALS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_N8N_CREDENTIALS]: MutationHelpers.set,
  [types.default.ADD_N8N_CREDENTIAL]: MutationHelpers.create,
  [types.default.UPDATE_N8N_CREDENTIAL]: MutationHelpers.update,
  [types.default.DELETE_N8N_CREDENTIAL]: MutationHelpers.destroy,
  [types.default.SET_N8N_CREDENTIAL_TYPES](_state, data) {
    _state.credentialTypes = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
